import API from '../../../../commons/api/api';
import * as actionTypes from '../actions/type';

export const initialState = {
  token: '',
  statusCode: null,
  notices: {
    'list': [],
  },
  item: null,
  isProcessingItem: null,
  isProcessing: null,
  coutingVideo: 1,
  lastPage: 1,
  currentPage: 1,
  typeMsg: null,
  total: null,
};

const noticeReducers = (state  = initialState, action) => {
  const { payload } = action;
  switch (action.type) {

    case actionTypes.GET_NOTICE:

      return {
        ...state,
        isProcessing: true,
        type: action.type,
        typeMsg: action.params.type,
        lastPage: state.lastPage,
        total: null,
      };
    case actionTypes.GET_NOTICE_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        notices: {
          ...state.notices,
          ['list']: payload.data.data?.current_page == 1 ?
            payload.data.data?.data : [...state.notices?.list, ...payload.data.data?.data]
        },
        lastPage: payload.data.data?.last_page,
        currentPage: payload.data.data?.current_page,
        total: payload.data.data?.total,
        typeMsg: payload.type
      };

    case actionTypes.GET_NOTICE_DETAIL:
      return {
        ...state,
        isProcessingItem: true,
        item: null,
        type: action.type
      };
    case actionTypes.UPDATE_NOTICE_LIST:
      return {
        ...state,
        notices: {
          ...state.notices,
          ['list']: payload
        },
        type: action.type
      };
    case actionTypes.GET_NOTICE_DETAIL_SUCCESS:
      return {
        ...state,
        isProcessingItem: false,
        item: payload.data
      };
    default:
      return state;
  }
};

export default noticeReducers;
